import React from 'react';

const Logo = ({ className = "", iconOnly = false }) => {
  const sizeClasses = className.includes('w-') || className.includes('h-') ? '' : 'w-8 h-8';
  
  return (
    <div className={`flex items-center gap-2 ${className}`} role="img" aria-label="Mobile First Pro Logo">
      <div className={`relative flex-shrink-0 ${sizeClasses} aspect-square`} aria-hidden="true">
        <svg 
          viewBox="0 0 100 100" 
          className="w-full h-full drop-shadow-md"
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="logo-grad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#ea580c" />
              <stop offset="100%" stopColor="#c2410c" />
            </linearGradient>
          </defs>
          <path 
            d="M50 5 L89 27.5 V72.5 L50 95 L11 72.5 V27.5 L50 5Z" 
            fill="url(#logo-grad)"
          />
          <path 
            d="M30 65 V35 L50 45 L70 35 V65" 
            stroke="white" 
            strokeWidth="8" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
          />
          <rect x="35" y="70" width="6" height="4" rx="1" fill="white" fillOpacity="0.6" />
          <rect x="47" y="66" width="6" height="8" rx="1" fill="white" fillOpacity="0.8" />
          <rect x="59" y="62" width="6" height="12" rx="1" fill="white" />
        </svg>
      </div>
      {!iconOnly && (
        <span className="text-lg font-black tracking-tighter text-gray-900 whitespace-nowrap leading-none uppercase">
          Mobile <span className="text-orange-700">First</span> Pro
        </span>
      )}
    </div>
  );
};

export default Logo;